import React from 'react'

const InfluenzaFluTests = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 pt-md-5 pt-4 pb-md-4'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    What Is Influenza?
                </div>
                <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className=''>
                <div className='fs-ss-20-3 text-montserrat fw-600 text-ss-black' style={{ fontStyle:'italic', letterSpacing:'0.5px'}}>
                    Flu Testing Chicago
                </div>
            </div>

            <div className='py-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Influenza, more commonly referred to as flu, is a respiratory illness brought on by an infection with the influenza A, B, C, or D virus. People spread influenza viruses primarily through droplets released into the air when the affected person talks, coughs, or sneezes. United Lab Care offers rapid and free<strong>* flu testing services in the Chicago.</strong> A simple swab test can diagnose<strong> 19 different viruses within 24 hours.</strong> Our flu test in Chicago have an<strong> accuracy higher than 97%.</strong> 
                </div>
            </div>

            <div className='pt-md-2'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Flu season is the time of the year when the virus is prevalent. In the US, influenza season can start as soon as October and end as late as May. The infection typically spreads from one individual to another through hacking or wheezing. Additionally, you can contract the flu by touching your nose, eyes, or mouth to a surface infected with the virus.
                </div>
            </div>
        </div>
    </div>
  )
}

export default InfluenzaFluTests